import { Module } from 'vuex-smart-module';
import ReasonsCommunicationActions from './actions';
import ReasonsCommunicationGetters from './getters';
import ReasonsCommunicationMutations from './mutations';
import { ReasonsCommunicationState } from './state';

export default new Module({
  state: ReasonsCommunicationState,
  mutations: ReasonsCommunicationMutations,
  actions: ReasonsCommunicationActions,
  getters: ReasonsCommunicationGetters,
});
